// extracted by mini-css-extract-plugin
module.exports = {"module":"button_module__28oA9"};